// extracted by mini-css-extract-plugin
module.exports = {"mobileExternalLink":"mobileExternalLink__2lAZe","tabRowWrapper":"tabRowWrapper__2n2EJ","tabRow":"tabRow__3OaF4","singleOptionTabRow":"singleOptionTabRow__W9aiL"};